<script lang="ts">
  import { generateBlogLdJson } from "@lib";
  import type { BlogPost } from "@internalTypes";
  export let post:BlogPost = null;
</script>
<svelte:head>
  {@html generateBlogLdJson(post) }
</svelte:head>
